<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Course Combinations"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('course_combinations')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Course Combinations
      Tool. The course combinations tool displays course combinations with
      different number of courses.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Course Combinations
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Combo Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Course Combo Table Results"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Course Combinations Tool At First Glance ---------->

        <h3 class="h3-second-header">
          Course Combinations Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 18.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageCourseCombinationsFig18']"
            alt=""
          />
          <p class="picture-caption">
            Figure 18: Course Combinations Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Course Combinations Form Guide ---------->
        <h3 class="h3-second-header">Course Combinations Form Submission</h3>

        <ol class="ordered-list">
          <li>
            Select the Student Type (All Student Types, FTIC, Transfer FCS AA)
          </li>
          <li>Select the Semester (Fall, Spring, Summer)</li>
          <li>Select the Number of Courses (1-5)</li>
          <li>Select Course Level(s) (Any, 1000, 2000, 3000, 4000)</li>
          <li>
            *Lastly, click on the ‘Submit’ button to generate results for Course
            Combinations.
          </li>
        </ol>
      </div>

      <div class="left-align-div">
        <p class=""></p>
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageCourseCombinationsFig18a']"
            alt=""
          />
          <p class="picture-caption">
            Figure 18a: Course Combinations Form Submission Example
          </p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div id="results" class="left-align-div">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After the form submission, you will get a table like the screenshot
            (Figure 19) below. On the top of the table, you will see filter
            inputs depending on the number of courses you've filtered for in the
            combo filter. You can then filter for the course number you would
            like to see in each course filter input (Course 1, Course 2, ...).
            The table automatically updates to the filtered course number.
          </li>
          <div>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageCourseCombinationsFig19']"
              alt=""
            />
            <p class="picture-caption">
              Figure 19: Pass Rate for Two-Course Combinations
            </p>
          </div>
          <li>
            After filtering the table for ANT2000 in the filter for course 1,
            you can see that the table changes to display only course
            combinations with ANT2000 in Course 1 column in the table.(Figure
            19a)
          </li>
          <div>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageCourseCombinationsFig19a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 19a: Filtered Table of Two-Course Combinations with ANT2000
              for the first column
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Course Combinations',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
